import { Router,NavigationExtras } from '@angular/router';
import { LoaderService } from './../loder_service/loader.service';
import { DataService } from './../data.service';
import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
order_list:any;
  constructor(public router:Router,public toastService:LoaderService, public restApi:DataService,public storage:Storage) { }

  ngOnInit() {}
ionViewWillEnter(){
  this.toastService.showLoader('')
 
   
   let postparams={
    usersessionId: localStorage.getItem('user_id')
   }
   this.restApi.my_order(postparams).subscribe((data:any)=>{
     this.order_list=data;
     console.log(this.order_list);
     this.toastService.hideLoader()
     
   },(error:any)=>{
    this.toastService.hideLoader()
   })
 
}
cancelOrdr(order_details_id){
  
  console.log(order_details_id);
  if(confirm('are you sure you want to cancel this Order?'))
  {
    this.toastService.showLoader('');
  
      console.log();
      let postparams={
        order_id:order_details_id, 
        usersessionid:localStorage.getItem('user_id')
      }
      this.restApi.cancel_order(postparams).subscribe((data:any)=>{
        this.ionViewWillEnter()
        this.toastService.hideLoader()
        this.toastService.create('Canceled')
      },(error:any)=>{
        this.toastService.hideLoader()
      })
    

  }
 
}
goto_product_details(pro){
  let product_id=pro.product_id
  let navigationExtras: NavigationExtras = {
    queryParams: {
      product_id: JSON.stringify(product_id),
    }
  }; 
  console.log(pro.product_id);
  //routerLink="/productdetails"
  this.router.navigate(['/productdetails'], navigationExtras); 
}
}
